import { jsx as _jsx } from "react/jsx-runtime";
import coverageBot1 from "../assets/ui/coverageBottom1.svg";
import coverageBot2 from "../assets/ui/coverageBottom2.svg";
import coverageBot3 from "../assets/ui/coverageBottom3.svg";
import coverageTop1 from "../assets/ui/coverageTop1.svg";
import coverageTop2 from "../assets/ui/coverageTop2.svg";
import coverageTop3 from "../assets/ui/coverageTop3.svg";
import { CircleButton } from "./circleButton";
import * as S from "./coverageButton.styles";
export function CoverageButton({ isDisabled, isSelected, mask0, mask1, maskPosition, maskSize, onClick, }) {
    return (_jsx(CircleButton, { isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, children: _jsx(S.ItemMask0, { "$mask": mask0, children: _jsx(S.ItemMask1, { "$mask": mask1, "$position": maskPosition, "$size": maskSize }) }) }));
}
export function CoverageButtonB1(props) {
    return (_jsx(CoverageButton, Object.assign({ mask0: coverageBot3, mask1: coverageBot1, maskPosition: "50% 10%", maskSize: "65%" }, props)));
}
export function CoverageButtonB2(props) {
    return (_jsx(CoverageButton, Object.assign({ mask0: coverageBot3, mask1: coverageBot2, maskPosition: "50% 10%", maskSize: "65%" }, props)));
}
export function CoverageButtonB3(props) {
    return (_jsx(CoverageButton, Object.assign({ mask0: coverageBot3, mask1: coverageBot3 }, props)));
}
export function CoverageButtonT1(props) {
    return (_jsx(CoverageButton, Object.assign({ mask0: coverageTop3, mask1: coverageTop1, maskPosition: "50% 25%", maskSize: "50%" }, props)));
}
export function CoverageButtonT2(props) {
    return (_jsx(CoverageButton, Object.assign({ mask0: coverageTop3, mask1: coverageTop2, maskPosition: "50% 75%", maskSize: "50%" }, props)));
}
export function CoverageButtonT3(props) {
    return (_jsx(CoverageButton, Object.assign({ mask0: coverageTop3, mask1: coverageTop3 }, props)));
}
